<template>
    <v-container class="my-5">
        <!--    Diálogo  Modal para mostrar mensaje Número de Celular incorrecto    -->
        <v-dialog v-model="dialogCellNumberWrong" max-width="290">
            <v-card>
                <v-card-title class="headline">{{$t('aviso')}}</v-card-title>
                <v-card-text>{{$t('cellphone_wrong')}}</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="dialogCellNumberWrong = false">{{$t('aceptar')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--    Diálogo  Modal para Cambiar Permisos (Usuario -> Residente)    -->
        <v-dialog
                v-model="dialogMoveUp"
                max-width="400"
        >
            <v-form @submit.prevent="moveUpUserToResident()">
                <v-card class="elevation-5">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            {{$t('move_up_user_to_resident')}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                                class="align-self-end"
                                color="red"
                                icon
                                @click="dialogMoveUp = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <v-layout row wrap>
                            <v-autocomplete
                                    v-model="emailGuest"
                                    :items="items"
                                    prepend-icon="mdi-email"
                                    :loading="isLoading"
                                    :search-input.sync="search2"
                                    :item-text="example"
                                    item-value="id"
                                    :placeholder="$t('placeholder_invitados2')"
                                    :label="$t('usuarios')"
                                    :error-messages="errores.idUser"
                                    :no-data-text="$t('no_resultados')"
                                    clearable
                                    autocomplete="off"
                            >
                                <template v-slot:selection="data">
                                    <v-chip
                                            v-bind="data.attrs"
                                            :input-value="data.selected"
                                            @click="data.select"
                                    >
                                        <v-avatar left>
                                            <v-img :src="data.item.avatar"></v-img>
                                        </v-avatar>
                                        {{ data.item.first_name }} {{data.item.last_name}}
                                    </v-chip>
                                </template>
                                <template v-slot:item="data">
                                    <template v-if="typeof data.item !== 'object'">
                                        <v-list-item-content v-text="data.item"></v-list-item-content>
                                    </template>
                                    <template v-else>
                                        <v-list-item-avatar>
                                            <img :src="data.item.avatar">
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title>{{ data.item.first_name }} {{data.item.last_name}}</v-list-item-title>
                                            <v-list-item-sub-title v-html="data.item.group"></v-list-item-sub-title>
                                        </v-list-item-content>
                                    </template>
                                </template>
                            </v-autocomplete>
                        </v-layout>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                                color="primary"
                                @click="dialogMoveUp = false"
                        >
                            {{$t('cerrar')}}
                        </v-btn>
                        <v-spacer/>
                        <v-btn
                                color="primary"
                                type="submit"
                                :loading="loading"
                        >
                            {{$t('modificar')}}
                            <v-icon dark right>mdi-swap-horizontal</v-icon>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <!--   Diálogo para Mostrar un mensaje al Eliminar Residentes     -->
        <v-dialog
                v-model="deleteDialog"
                max-width="500"
        >
            <v-card>
                <v-card-title class="headline">
                    {{$t('msg_delete_resident')}}
                </v-card-title>
                <v-card-text>
                    {{$t('msg_accion_deshacer')}}
                </v-card-text>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            @click="deleteDialog = false"
                    >
                        No
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            @click="deleteResident()"
                    >
                        {{$t('Si')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--     Diálogo Modal Persistente para Recortar la Imagen Identificacón Oficial Frontal      -->
        <v-dialog v-model="dialogImageFront" persistent scrollable max-width="800px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('recortar_imagen')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <clipper-fixed
                            :rotate="degrees"
                            :ratio="ratio"
                            ref="clipperImageFront"
                            :src="imageFrontURL">
                    </clipper-fixed>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-col>
                        <v-row xs12 class="justify-center">
                            <v-radio-group
                                    v-model="ratio"
                                    name="ratio"
                                    row
                                    label="Ratio"
                                    :mandatory="false"
                            >
                                <v-radio label="1:1" value="1"></v-radio>
                                <v-radio label="3:2" value="1.5"></v-radio>
                                <v-radio label="4:3" value="1.3333333333333333"></v-radio>
                                <v-radio label="16:9" value="1.7777777777777777"></v-radio>
                            </v-radio-group>
                        </v-row>
                        <v-row xs12 class="justify-center mr-6">
                            <v-slider
                                    v-model="degrees"
                                    :label="$t('grados')"
                                    step="1"
                                    max="180"
                                    min="-180"
                                    thumb-label="always"
                            ></v-slider>
                        </v-row>
                        <v-row class="justify-center">
                            <v-btn
                                    color="primary"
                                    @click="getCutingFront()"
                            >{{$t('recortar')}}</v-btn>
                        </v-row>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--     Diálogo Modal Persistente para Recortar la Imagen Identificacón Oficial Atrás      -->
        <v-dialog v-model="dialogImageBack" persistent scrollable max-width="800px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('recortar_imagen')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text class="justify-center">
                    <clipper-fixed
                            :rotate="degrees"
                            :ratio="ratio"
                            ref="clipperImageBack"
                            :src="imageBackURL">
                    </clipper-fixed>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-col>
                        <v-row xs12 class="justify-center">
                            <v-radio-group
                                    v-model="ratio"
                                    name="ratio"
                                    row
                                    label="Ratio"
                                    :mandatory="false"
                            >
                                <v-radio label="1:1" value="1"></v-radio>
                                <v-radio label="3:2" value="1.5"></v-radio>
                                <v-radio label="4:3" value="1.3333333333333333"></v-radio>
                                <v-radio label="16:9" value="1.7777777777777777"></v-radio>
                            </v-radio-group>
                        </v-row>
                        <v-row xs12 class="justify-center mr-6">
                            <v-slider
                                    v-model="degrees"
                                    :label="$t('grados')"
                                    step="1"
                                    max="180"
                                    min="-180"
                                    thumb-label="always"
                            ></v-slider>
                        </v-row>
                        <v-row class="justify-center">
                            <v-btn
                                    color="primary"
                                    @click="getCutingBack()"
                            >{{$t('recortar')}}</v-btn>
                        </v-row>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--     Diálogo Modal Persistente para Recortar la Foto de perfil      -->
        <v-dialog v-model="dialogImageProfile" persistent scrollable max-width="800px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('recortar_imagen')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <clipper-fixed
                            class="basic lg"
                            :src="imageProfileURL"
                            ref="clipperImageProfile"
                            :rotate="degrees"
                            :round="true"
                            preview="preview">
                    </clipper-fixed>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-col>
                        <v-row xs12 class="justify-center mr-6">
                            <v-slider
                                    v-model="degrees"
                                    :label="$t('grados')"
                                    step="1"
                                    max="180"
                                    min="-180"
                                    thumb-label="always"
                            ></v-slider>
                        </v-row>
                        <v-row xs12 class="justify-center">
                            <v-btn
                                    color="primary"
                                    @click="getCutingProfile()"
                            >{{$t('recortar')}}</v-btn>
                        </v-row>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <h2 class="subheading grey--text">{{ $t('residentes') }}</h2>
        <v-layout align-center justify-center fill-height>
            <v-dialog v-model="dialog" persistent scrollable max-width="800px">
                <template v-slot:activator="{ on }">
                    <v-layout row wrap class="justify-center">
                        <v-btn
                                v-show="getProfile.can_send === true"
                                color="primary"
                                dark
                                v-on="on"
                                @click="update = false,
                                cleanFields()"> + {{ $t('anadir_residente') }}
                        </v-btn>
                        <v-btn
                                v-show="getProfile.can_send === true"
                                arrow_upward
                                color="primary"
                                @click="dialogMoveUp = true, emailGuest = '', entries = [], errores = [] "
                        >
                            <v-icon dark left>mdi-swap-horizontal</v-icon>
                            {{$t('cambiar_permisos')}}
                        </v-btn>
                    </v-layout>
                </template>
                <v-form
                        @submit.prevent="update
                                        ? updateResident(id_update)
                                        : createResident()">
                    <v-card class="elevation-5">
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>
                                {{ $t('residentes') }}
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn
                                    class="align-self-end"
                                    color="red"
                                    icon
                                    @click="clear(), dialog = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text>
                            <!-- INFORMACIÓN PERSONAL -->
                            <v-subheader class="title primary--text pl-0">{{ $t('personal_information') || 'Información Personal' }}</v-subheader>
                            <v-divider class="mb-4"></v-divider>
                            <v-layout row wrap>
                                <v-flex xs12 sm6 class="px-3">
                                    <v-text-field
                                            v-model="first_name"
                                            prepend-icon="mdi-account"
                                            name="first_name"
                                            :label="$t('Nombre')"
                                            :error-messages="errores_seg.first_name"
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 class="px-3">
                                    <v-text-field
                                            v-model="last_name"
                                            prepend-icon="mdi-account-outline"
                                            name="last_name"
                                            :label="$t('Apellido')"
                                            :error-messages="errores_seg.last_name"
                                    >
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs12 sm6 class="px-3">
                                    <v-text-field
                                            autocomplete="username"
                                            v-model="email"
                                            prepend-icon="mdi-email"
                                            name="email"
                                            label="E-Mail"
                                            :error-messages="errores_seg.email"
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 class="px-3">
                                    <vue-tel-input
                                            class="mt-3 mb-3"
                                            v-model="celular"
                                            @onInput="onInput"
                                    >
                                        <v-alert v-if="errores_seg.cellNumber" type="error">{{errores_seg.cellNumber}}</v-alert>
                                    </vue-tel-input>
                                    <v-alert outlined v-if="errores_seg.cellNumber" type="error" class="mt-n3">{{errores_seg.cellNumber}}</v-alert>
                                </v-flex>
                            </v-layout>

                            <!-- CONFIGURACIÓN Y PERMISOS -->
                            <v-subheader class="title primary--text pl-0 mt-4">{{ $t('configuration_permissions') || 'Configuración y Permisos' }}</v-subheader>
                            <v-divider class="mb-4"></v-divider>
                            <v-layout row wrap>
                                <v-flex xs12 class="px-3">
                                    <v-checkbox
                                            v-model="can_send"
                                            name="can_send"
                                            :label="$t('puede_enviar')"
                                            :error-messages="errores.can_send"
                                            hide-details
                                            class="mb-3"
                                    ></v-checkbox>
                                </v-flex>
                                <v-flex xs12 sm6 class="px-3">
                                    <v-checkbox
                                            v-model="notify_on_no_code_access"
                                            name="notify_on_no_code_access"
                                            :label="$t('notify_on_no_code_access') || 'Notificaciones por accesos sin código'"
                                            :error-messages="errores.notify_on_no_code_access"
                                            hide-details
                                            class="mb-3"
                                    ></v-checkbox>
                                </v-flex>
                                <v-flex xs12 sm6 class="px-3">
                                    <v-checkbox
                                            v-model="notify_on_worker_access"
                                            name="notify_on_worker_access"
                                            :label="$t('notify_on_worker_access') || 'Notificaciones por acceso de trabajadores'"
                                            :error-messages="errores.notify_on_worker_access"
                                            hide-details
                                            class="mb-3"
                                    ></v-checkbox>
                                </v-flex>
                            </v-layout>

                            <!-- AUTENTICACIÓN -->
                            <v-subheader class="title primary--text pl-0 mt-4">{{ $t('authentication') || 'Autenticación' }}</v-subheader>
                            <v-divider class="mb-4"></v-divider>
                            <v-checkbox
                                    v-model="change_password"
                                    v-if="update" disable
                                    name="change_password"
                                    label="Cambiar Contraseña"
                                    class="px-3"
                            ></v-checkbox>
                            <ValidationObserver class="px-3 d-block">
                                <ValidationProvider :rules="change_password ? 'required|password:@confirm' : ''" v-slot="{ errors }">
                                    <v-text-field
                                            autocomplete="new-password"
                                            v-model="password"
                                            :disabled="update && !change_password ? true: false"
                                            prepend-icon="mdi-lock"
                                            :label="$t('password')"
                                            :type="show ? 'text' : 'password'"
                                            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                            @click:append="show = !show"
                                            :error-messages="change_password ? errores_seg.password : ''">
                                    </v-text-field>
                                    <span>{{ errors[0] }}</span>
                                </ValidationProvider>
                                <ValidationProvider name="confirm" :rules="change_password ? 'required' : ''" v-slot="{ errors }">
                                    <v-text-field
                                            autocomplete="new-password"
                                            v-model="confirmation"
                                            :disabled="update  && !change_password ? true: false"
                                            prepend-icon="mdi-lock"
                                            :label="$t('password_confirm')"
                                            :type="show ? 'text' : 'password'"
                                            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                            @click:append="show = !show">
                                    </v-text-field>
                                    <span>{{ errors[0] }}</span>
                                </ValidationProvider>
                            </ValidationObserver>

                            <!-- FOTOGRAFÍAS E IDENTIFICACIÓN -->
                            <v-subheader class="title primary--text pl-0 mt-4">{{ $t('identification_photos') || 'Fotografías e Identificación' }}</v-subheader>
                            <v-divider class="mb-4"></v-divider>
                            <v-layout row wrap>
                                <v-flex xs12 sm12 md4 class="px-2 mb-3">
                                    <v-card outlined class="edge pt-3 pb-3 pl-3 pr-3 text-center h-100 fill-height d-flex flex-column justify-center align-center">
                                        <v-label>{{$t('foto_perfil')}}</v-label>
                                        <div class="wrapper mx-auto mt-2">
                                            <img
                                                    :src="resultProfileURL"
                                                    v-if="resultProfileURL">
                                        </div>
                                        <div class="mt-auto">
                                            <v-btn color="primary" small class="mt-4">
                                                <clipper-upload
                                                        @input="dialog = false, dialogImageProfile = true, degrees = 0, ratio = '1'"
                                                        accept="image/*"
                                                        v-model="imageProfileURL"
                                                >
                                                    {{$t('subir_imagen')}}
                                                </clipper-upload>
                                            </v-btn>
                                            <v-alert
                                                    v-if="errores_seg.avatar"
                                                    type="error"
                                                    outlined
                                                    transition="scale-transition"
                                                    class="mt-3 mx-2"
                                            >
                                                {{errores_seg.avatar}}
                                            </v-alert>
                                        </div>
                                    </v-card>
                                </v-flex>
                                <v-flex xs12 sm6 md4 class="px-2 mb-3">
                                    <v-card outlined class="edge pt-3 pb-3 pl-3 pr-3 text-center h-100 fill-height d-flex flex-column justify-center align-center">
                                        <v-label>{{$t('foto_ine')}}<br>[{{$t('frente')}}]</v-label>
                                        <v-img
                                                class="pt-3 pb-3 mx-auto"
                                                :src="resultFrontURL"
                                                v-if="resultFrontURL"
                                                width="auto"
                                                height="180"
                                                contain
                                        ></v-img>
                                        <div class="mt-auto">
                                            <v-btn color="primary" small class="mt-4">
                                                <clipper-upload
                                                        @input="dialog = false, dialogImageFront = true, degrees = 0, ratio = '1'"
                                                        accept="image/*"
                                                        v-model="imageFrontURL"
                                                >
                                                    {{$t('subir_imagen')}}
                                                </clipper-upload>
                                            </v-btn>
                                            <v-alert
                                                    v-if="errores_seg.idFront"
                                                    type="error"
                                                    outlined
                                                    transition="scale-transition"
                                                    class="mt-3 mx-2"
                                            >
                                                {{errores_seg.idFront}}
                                            </v-alert>
                                        </div>
                                    </v-card>
                                </v-flex>
                                <v-flex xs12 sm6 md4 class="px-2 mb-3">
                                    <v-card outlined class="edge pt-3 pb-3 pl-3 pr-3 text-center h-100 fill-height d-flex flex-column justify-center align-center">
                                        <v-label>{{$t('foto_ine')}}<br>[{{$t('atras')}}]</v-label>
                                        <v-img
                                                class="pt-3 pb-3 mx-auto"
                                                :src="resultBackURL"
                                                v-if="resultBackURL"
                                                width="auto"
                                                height="180"
                                                contain
                                        ></v-img>
                                        <div class="mt-auto">
                                            <v-btn color="primary" small class="mt-4">
                                                <clipper-upload
                                                        @input="dialog = false, dialogImageBack = true, degrees = 0, ratio = '1'"
                                                        accept="image/*"
                                                        v-model="imageBackURL"
                                                >
                                                    {{$t('subir_imagen')}}
                                                </clipper-upload>
                                            </v-btn>
                                            <v-alert
                                                    v-if="errores_seg.idBack"
                                                    type="error"
                                                    outlined
                                                    transition="scale-transition"
                                                    class="mt-3 mx-2"
                                            >
                                                {{errores_seg.idBack}}
                                            </v-alert>
                                        </div>
                                    </v-card>
                                </v-flex>
                            </v-layout>

                            <v-alert
                                    :value=alerta
                                    type="warning"
                                    outlined
                                    transition="scale-transition"
                            >
                                Fallo con el Servidor
                            </v-alert>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn
                                    color="primary"
                                    @click="clear(),
                                    dialog = false"
                            >{{$t('cerrar')}}
                            </v-btn>
                            <v-spacer/>
                            <v-btn
                                    v-if="update"
                                    :loading="loading"
                                    color="primary"
                                    type="submit"
                            >{{$t('modificar')}}
                            </v-btn>
                            <v-btn
                                    v-else
                                    :loading="loading"
                                    color="primary"
                                    type="submit"
                            >{{$t('agregar')}}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
            <!--     Diálogo Modal para Registrar Invitado       -->
            <v-dialog v-model="dialogGuest" persistent scrollable max-width="600px">
<!--                <template v-slot:activator="{ on }">-->
<!--                    <v-btn-->
<!--                            color="green darken-4"-->
<!--                            dark-->
<!--                            v-on="on"-->
<!--                            @click="bandGuest = true, cleanFields()">-->
<!--                        + {{ $t('add_guest') }}-->
<!--                    </v-btn>-->
<!--                </template>-->
                <v-card class="elevation-5">
                    <v-toolbar class="mb-5" dark color="green darken-4">
                        <v-toolbar-title>
                            {{ $t('invitado') }}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                                class="align-self-end"
                                color="red"
                                icon
                                @click="clear(), bandGuest = false, dialogGuest = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <v-form
                                class="mb-4"
                                @submit.prevent="createGuest()">
                            <v-text-field
                                    v-model="first_name"
                                    autofocus
                                    prepend-icon="mdi-account"
                                    name="first_name"
                                    :label="$t('Nombre')"
                                    :error-messages="errores.first_name"
                            >
                            </v-text-field>
                            <v-text-field
                                    v-model="last_name"
                                    prepend-icon="mdi-account-outline"
                                    name="last_name"
                                    :label="$t('Apellido')"
                                    :error-messages="errores.last_name"
                            >
                            </v-text-field>
                            <v-layout row wrap>
                                <v-flex xs12 sm6 class="edge pt-3 pb-3 pl-3 pr-3">
                                    <v-label>
                                        {{$t('foto_ine')}}<br>[{{$t('frente')}}]
                                    </v-label>
                                    <br>
                                    <v-img
                                            class="pt-3 pb-3"
                                            :src="resultFrontURL"
                                            v-if="resultFrontURL"
                                            width="auto"
                                            height="180"
                                    ></v-img>
                                    <br>
                                    <v-btn
                                            color="green darken-4">
                                        <clipper-upload
                                                @input="dialog = false, dialogImageFront = true"
                                                accept="image/*"
                                                v-model="imageFrontURL"
                                        >
                                            {{$t('subir_imagen')}}
                                        </clipper-upload>
                                    </v-btn>
                                    <br>
                                    <v-alert
                                            v-if="errores.idFront"
                                            type="error"
                                            outlined
                                            transition="scale-transition"
                                    >
                                        {{errores.idFront}}
                                    </v-alert>
                                </v-flex>
                                <v-flex xs12 sm6 class="edge pt-3 pb-3 pl-3 pr-3">
                                    <v-label>
                                        {{$t('foto_ine')}}<br>[{{$t('atras')}}]
                                    </v-label>
                                    <br>
                                    <v-img
                                            class="pt-3 pb-3"
                                            :src="resultBackURL"
                                            v-if="resultBackURL"
                                            width="auto"
                                            height="180"
                                    ></v-img>
                                    <br>
                                    <v-btn
                                            color="green darken-4">
                                        <clipper-upload
                                                @input="dialog = false, dialogImageBack = true"
                                                accept="image/*"
                                                v-model="imageBackURL"
                                        >
                                            {{$t('subir_imagen')}}
                                        </clipper-upload>
                                    </v-btn>
                                    <br>
                                    <v-alert
                                            v-if="errores.idBack"
                                            type="error"
                                            outlined
                                            transition="scale-transition"
                                    >
                                        {{errores.idBack}}
                                    </v-alert>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs12 sm6 class="edge pt-3 pb-3 pl-3 pr-3">
                                    <div class="splash-info">
                                        <v-label>
                                            {{$t('foto_perfil')}}
                                        </v-label>
                                        <br>
                                        <div class="wrapper">
                                            <img
                                                    :src="resultProfileURL"
                                                    v-if="resultProfileURL">
                                        </div>
                                        <br>
                                        <v-btn
                                                color="green darken-4">
                                            <clipper-upload
                                                    @input="dialog = false, dialogImageProfile = true"
                                                    accept="image/*"
                                                    v-model="imageProfileURL"
                                            >
                                                {{$t('subir_imagen')}}
                                            </clipper-upload>
                                        </v-btn>
                                        <br>
                                        <v-alert
                                                v-if="errores.avatar"
                                                type="error"
                                                outlined
                                                transition="scale-transition"
                                        >
                                            {{errores.avatar}}
                                        </v-alert>
                                    </div>
                                </v-flex>
                            </v-layout>
                            <vue-tel-input
                                    class="mt-3 mb-3"
                                    v-model="celular"
                                    @onInput="onInput"
                            >
                                <v-alert v-if="errores.cellNumber" type="error">{{errores.cellNumber}}</v-alert>
                            </vue-tel-input>
                            <v-alert outlined v-if="errores.cellNumber" type="error">{{errores.cellNumber}}</v-alert>
                            <v-layout row wrap>
                                <v-flex v-bind:class="(update) ? 'xs12 sm6 md6 lg6 xl6' : 'xs12 sm12 md12 lg12 xl12'">
                                    <v-text-field
                                            v-model="email"
                                            prepend-icon="mdi-email"
                                            name="email"
                                            label="E-Mail"
                                            :error-messages="errores.email"
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex v-show="update" v-bind:class="(update) ? 'xs12 sm6 md6 lg6 xl6' : 'xs12 sm12 md12 lg12 xl12'">
                                    <v-checkbox
                                            v-model="activa"
                                            name="activa"
                                            :label="$t('Activo')"
                                            :error-messages="errores.activa"
                                    ></v-checkbox>
                                </v-flex>
                            </v-layout>
                            <v-checkbox
                                    v-model="change_password"
                                    v-if="update" disable
                                    name="change_password"
                                    label="Cambiar Contraseña"
                            ></v-checkbox>
                            <ValidationObserver>
                                <ValidationProvider :rules="change_password ? 'required|password:@confirm' : ''" v-slot="{ errors }">
                                    <v-text-field
                                            v-model="password"
                                            :disabled="update && !change_password ? true: false"
                                            prepend-icon="mdi-lock"
                                            :label="$t('password')"
                                            :type="show ? 'text' : 'password'"
                                            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                            @click:append="show = !show"
                                            :error-messages="change_password ? errores_seg.password : ''">
                                    </v-text-field>
                                    <span>{{ errors[0] }}</span>
                                </ValidationProvider>
                                <ValidationProvider name="confirm" :rules="change_password ? 'required' : ''" v-slot="{ errors }">
                                    <v-text-field
                                            v-model="confirmation"
                                            :disabled="update  && !change_password ? true: false"
                                            prepend-icon="mdi-lock"
                                            :label="$t('password_confirm')"
                                            :type="show ? 'text' : 'password'"
                                            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                            @click:append="show = !show">
                                    </v-text-field>
                                    <span>{{ errors[0] }}</span>
                                </ValidationProvider>
                            </ValidationObserver>
                            <v-btn
                                    color="green darken-4"
                                    @click="clear(),
                                    dialogGuest = false,
                                    bandGuest = false"
                            >{{$t('cerrar')}}
                            </v-btn>
                            <v-btn
                                    color="green darken-4"
                                    type="submit"
                            >{{$t('agregar')}}
                            </v-btn>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-layout>
        <v-layout class="my-4" align-center justify-center fill-height>
            <v-flex >
                <v-card-title>
                    {{$t('residentes')}}
                    <v-spacer></v-spacer>
                    <v-text-field
                            v-model="search"
                            append-icon="mdi-account-search"
                            :label="$t('Buscar')"
                            single-line
                            hide-details
                    ></v-text-field>
                </v-card-title>
                <v-data-table
                        :headers="headers"
                        :loading="loadingResidents"
                        :items="residents"
                        :search="search"
                        :footer-props="{
                            itemsPerPageOptions: [
                                {text: '5', value: 5},
                                {text: '10', value: 10},
                                {text: '25', value: 25},
                                {text: this.$t('todos'), value: -1}
                            ],
                            itemsPerPageText: $t('filas_por_pagina')
                        }"
                        :no-data-text="$t('no_records_yet')"
                        class="elevation-1"
                >
                    <template v-slot:items="props">
                        <td>{{ props.item.id }}</td>
                        <td>{{ props.item.id_usuario.first_name }}</td>
                        <td>{{ props.item.id_usuario.last_name }}</td>
                        <td>{{ props.item.id_usuario.celular }}</td>
                        <td>{{ props.item.id_usuario.email }}</td>
                    </template>
                    <template v-slot:item.can_send="{ item }">
                        <v-icon
                                v-if="item.can_send === true"
                                medium
                                color="primary"
                                class="mr-2"
                        >
                            mdi-check
                        </v-icon>
                        <v-icon
                                v-if="item.can_send === false"
                                medium
                                color="red"
                                class="mr-2"
                        >
                            mdi-close
                        </v-icon>
                        {{ item.can_send ? $t('Si') : 'No' }}
                    </template>
                    <template v-slot:item.action="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                        v-show="getProfile.can_send === true"
                                        v-bind="attrs"
                                        v-on="on"
                                        medium
                                        color="gray"
                                        class="mr-2"
                                        @click="fillFields(item), update = true, dialog = true, id_update = item.id"
                                >
                                    mdi-account-edit
                                </v-icon>
                            </template>
                            <span>{{$t('change')}}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                        v-bind="attrs"
                                        v-on="on"
                                        medium
                                        color="red"
                                        class="mr-2"
                                        @click="deleteDialog = true, idGuardDelete = item.id"
                                >
                                    mdi-delete
                                </v-icon>
                            </template>
                            <span>{{$t('delete')}}</span>
                        </v-tooltip>
                    </template>
                    <template v-slot:no-results>
                        <v-alert type="warning">
                            {{$t('ningun_resultado_1')}} "{{ search }}" {{$t('ningun_resultado_2')}}
                        </v-alert>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import axios from 'axios'
import store from '@/store'
import VuejsClipper from 'vuejs-clipper'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { mapState, mapGetters } from 'vuex'
import Vue from 'vue'
import { required } from 'vee-validate/dist/rules'

extend('password', {
  params: ['target'],
  validate (value, { target }) {
    return value === target
  },
  message: 'Password confirmation does not match'
})

extend('required', {
  ...required,
  message: 'This field is required'
})

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
Vue.use(VuejsClipper, {
  components: {
    clipperBasic: 'clipper-basic',
    clipperFixed: 'clipper-fixed',
    clipperUpload: 'clipper-upload'
  }
})

// const dictionary = {
//   en: {
//     messages: {
//       confirmed: () => 'The passwords didn\'t match',
//       required: () => 'This field is required'
//     }
//   },
//   es: {
//     messages: {
//       confirmed: () => 'Las contraseñas no coinciden',
//       required: () => 'Este campo es requerido'
//     }
//   }
// }

// Validator.localize(dictionary)
// const validator = new Validator({ confirmation: 'confirmed' })
// Falta investigar como cambiar el idioma de los mensajes
// con vue-validate
// validator.localize(this.$store.state.language);
// validator.localize('es')

export default {
  name: 'residents',
  created: function () {
    this.getResidents()
  },
  data: () => ({
    show: false,
    alerta: false,
    dialog: false,
    update: false,
    id_update: 0,
    id_house: '',
    first_name: '',
    last_name: '',
    celular: '',
    email: '',
    email_aux: '',
    celular_aux: '',
    password: '',
    errores: [],
    errores_seg: [],
    headers: [],
    houses: [],
    residents: [],
    can_send: '',
    notify_on_no_code_access: false,
    notify_on_worker_access: false,
    activa: '',
    change_password: '',
    loadingResidents: false,
    loading: false,
    confirmation: '',
    search: '',
    // Imágenes
    dialogImageFront: false,
    dialogImageBack: false,
    dialogImageProfile: false,
    imageFrontURL: '',
    imageBackURL: '',
    imageProfileURL: '',
    resultFrontURL: '',
    resultBackURL: '',
    resultProfileURL: '',
    resultAuxFrontURL: '',
    resultAuxBackURL: '',
    resultAuxProfileURL: '',
    // Delete Guard
    deleteDialog: false,
    idGuardDelete: 0,
    // Move Up
    dialogMoveUp: false,
    emailGuest: '',
    isLoading: false,
    search2: null,
    entries: [],
    band_cellphone: false,
    dialogCellNumberWrong: false,
    // Guest Data
    dialogGuest: false,
    bandGuest: false,
    degrees: 0,
    ratio: '1'
  }),
  beforeUpdate () {
    this.headers = [
      {
        text: this.$t('acciones'),
        align: 'center',
        value: 'action',
        sortable: false
      },
      {
        text: this.$t('Nombre'),
        align: 'left',
        sortable: true,
        value: 'idUser.first_name'
      },
      {
        text: this.$t('Apellido'),
        align: 'left',
        sortable: true,
        value: 'idUser.last_name'
      },
      {
        text: this.$t('celular'),
        align: 'left',
        sortable: true,
        value: 'idUser.cellNumber'
      },
      {
        text: 'E-Mail',
        align: 'left',
        sortable: true,
        value: 'idUser.email'
      },
      {
        text: this.$t('puede_enviar'),
        align: 'center',
        sortable: true,
        value: 'can_send'
      }
    ]
  },
  computed: {
    ...mapState(['language']),
    ...mapGetters(['getProfile']),
    fields () {
      if (!this.emailGuest) return []

      return Object.keys(this.emailGuest).map(key => {
        return {
          key,
          value: this.emailGuest[key] || 'n/a'
        }
      })
    },
    items () {
      return this.entries.map(entry => {
        const email = entry.first_name.length > this.descriptionLimit
          ? entry.first_name.slice(0, this.descriptionLimit) + '...'
          : entry.first_name

        return Object.assign({}, entry, { email })
      })
    }
  },
  watch: {
    isUpdating (val) {
      if (val) {
        setTimeout(() => (this.isUpdating = false), 3000)
      }
    },
    search2 (val) {
      if (val.length > 2) {
        this.isLoading = true
        // Lazily load input items
        const config = {
          method: 'get',
          url: 'https://residencial-services.intrare.app/guests/filter?search=' + val,
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'Token ' + store.getters.getToken
          }
        }
        axios(config)
          .then(response => {
            console.log(response.data)
            if (this.entries.length > 0) {
              for (var i = 0; i < response.data.length; i++) {
                this.entries.push(response.data[i])
              }
            } else {
              this.entries = response.data
            }
          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => (this.isLoading = false))
      }
    }
  },
  methods: {
    getResidents: function () {
      this.loadingResidents = true
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/resident/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.residents = response.data
          this.loadingResidents = false
        })
        .catch(error => {
          this.loadingResidents = false
          console.log(error)
        })
    },
    createResident: function () {
      if (this.band_cellphone === true) {
        this.errores = []
        this.errores_seg = []
        this.loading = true
        var bodyFormData = new FormData()
        var fileImageFront = null
        var fileImageBack = null
        var fileImageProfile = null

        bodyFormData.set('idUser.first_name', this.first_name)
        bodyFormData.set('idUser.last_name', this.last_name)
        bodyFormData.set('idUser.cellNumber', this.celular)
        bodyFormData.set('idUser.email', this.email.toLowerCase())
        bodyFormData.set('idUser.password', this.password)
        bodyFormData.set('idHouse', this.id_house)
        bodyFormData.set('can_send', this.can_send)
        bodyFormData.set('notify_on_no_code_access', this.notify_on_no_code_access)
        bodyFormData.set('notify_on_worker_access', this.notify_on_worker_access)
        if (this.resultFrontURL !== '' && this.resultFrontURL.length > 6) {
          fileImageFront = this.dataURLtoFile(this.resultFrontURL, 'ine_front.jpeg')
        }
        bodyFormData.append('idUser.idFront', fileImageFront)
        if (this.resultBackURL !== '' && this.resultBackURL.length > 6) {
          fileImageBack = this.dataURLtoFile(this.resultBackURL, 'ine_back.jpeg')
        }
        bodyFormData.append('idUser.idBack', fileImageBack)
        if (this.resultProfileURL !== '' && this.resultProfileURL.length > 6) {
          fileImageProfile = this.dataURLtoFile(this.resultProfileURL, 'avatar.jpeg')
        }
        bodyFormData.append('idUser.avatar', fileImageProfile)
        const config = {
          method: 'post',
          url: 'https://residencial-services.intrare.app/resident/',
          headers: {
            'Content-Type': 'application/json',
            'Accept-Language': this.language,
            'authorization': 'Token ' + store.getters.getToken
          },
          data: bodyFormData
        }
        axios(config)
          .then(ok => {
            this.loading = false
            this.getResidents()
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_message', this.$t('mensaje_residente_alta'))
            this.dialog = false
            setTimeout(this.clear, 3000)
          })
          .catch(error => {
            this.loading = false
            if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
              if (error.response.data) {
                this.errores = error.response.data
              }
              if (error.response.data.idUser) {
                this.errores_seg = error.response.data.idUser
              }
            }
          })
      } else {
        this.dialogCellNumberWrong = true
      }
    },
    createGuest: function () {
      if (this.band_cellphone === true) {
        this.errores = []
        this.loading = true
        var bodyFormData = new FormData()
        var fileImageFront = null
        var fileImageBack = null
        var fileImageProfile = null

        bodyFormData.set('first_name', this.first_name)
        bodyFormData.set('last_name', this.last_name)
        bodyFormData.set('cellNumber', this.celular)
        bodyFormData.set('email', this.email.toLowerCase())
        bodyFormData.set('username', this.email.toLowerCase())
        bodyFormData.set('password', this.password)
        if (this.resultFrontURL !== '' && this.resultFrontURL.length > 6) {
          fileImageFront = this.dataURLtoFile(this.resultFrontURL, 'ine_front.jpeg')
        }
        bodyFormData.append('idFront', fileImageFront)
        if (this.resultBackURL !== '' && this.resultBackURL.length > 6) {
          fileImageBack = this.dataURLtoFile(this.resultBackURL, 'ine_back.jpeg')
        }
        bodyFormData.append('idBack', fileImageBack)
        if (this.resultProfileURL !== '' && this.resultProfileURL.length > 6) {
          fileImageProfile = this.dataURLtoFile(this.resultProfileURL, 'avatar.jpeg')
        }
        bodyFormData.append('avatar', fileImageProfile)
        const config = {
          method: 'post',
          url: 'https://residencial-services.intrare.app/auth/users/',
          headers: {
            'Content-Type': 'application/json',
            'Accept-Language': this.language,
            'authorization': 'Token ' + store.getters.getToken
          },
          data: bodyFormData
        }
        axios(config)
          .then(ok => {
            this.loading = false
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_message', this.$t('mensaje_invitado_alta'))
            this.dialogGuest = false
            setTimeout(this.clear, 3000)
          })
          .catch(error => {
            this.loading = false
            if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
              if (error.response.data) {
                this.errores = error.response.data
              }
            }
          })
      } else {
        this.dialogCellNumberWrong = true
      }
    },
    updateResident: function (id) {
      if (this.band_cellphone === true) {
        this.errores = []
        this.errores_seg = []
        this.loading = true
        var bodyFormData = new FormData()
        var fileImageFront = null
        var fileImageBack = null
        var fileImageProfile = null

        // Evitar Campo Fraccionamiento vacío
        if (this.id_house === undefined) {
          this.id_house = ''
        }
        if (this.email_aux !== this.email) {
          // idUser['email'] = this.email.toLowerCase()
          bodyFormData.set('idUser.email', this.email.toLowerCase())
        }
        if (this.celular_aux !== this.celular) {
          bodyFormData.set('idUser.cellNumber', this.celular)
          // idUser['cellNumber'] = this.celular
        }
        if (this.change_password === true) {
          bodyFormData.set('idUser.password', this.password)
          // idUser['password'] = this.password
        }
        bodyFormData.set('can_send', this.can_send)
        bodyFormData.set('notify_on_no_code_access', this.notify_on_no_code_access)
        bodyFormData.set('notify_on_worker_access', this.notify_on_worker_access)
        if (this.resultFrontURL !== this.resultAuxFrontURL) {
          const newID = this.$uuid.v4()
          if (this.resultFrontURL !== '' && this.resultFrontURL.length > 6) {
            fileImageFront = this.dataURLtoFile(this.resultFrontURL, 'ine_front' + newID + '.jpeg')
          }
          bodyFormData.append('idUser.idFront', fileImageFront)
        }
        if (this.resultBackURL !== this.resultAuxBackURL) {
          const newID = this.$uuid.v4()
          if (this.resultBackURL !== '' && this.resultBackURL.length > 6) {
            fileImageBack = this.dataURLtoFile(this.resultBackURL, 'ine_back' + newID + '.jpeg')
          }
          bodyFormData.append('idUser.idBack', fileImageBack)
        }
        if (this.resultProfileURL !== this.resultAuxProfileURL) {
          const newID = this.$uuid.v4()
          if (this.resultProfileURL !== '' && this.resultProfileURL.length > 6) {
            fileImageProfile = this.dataURLtoFile(this.resultProfileURL, 'avatar' + newID + '.jpeg')
          }
          bodyFormData.append('idUser.avatar', fileImageProfile)
        }
        bodyFormData.set('idUser.first_name', this.first_name)
        bodyFormData.set('idUser.last_name', this.last_name)
        bodyFormData.set('idHouse', this.id_house)
        const config = {
          method: 'patch',
          url: 'https://residencial-services.intrare.app/resident/' + id,
          headers: {
            'Content-Type': 'application/json',
            'Accept-Language': this.language,
            'authorization': 'Token ' + store.getters.getToken
          },
          data: bodyFormData
        }
        axios(config)
          .then(ok => {
            this.loading = false
            this.getResidents()
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_message', this.$t('mensaje_residente_modificado'))
            this.dialog = false
            setTimeout(this.clear, 3000)
          })
          .catch(error => {
            this.loading = false
            console.log(error.response.data)
            if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
              if (error.response.data) {
                this.errores = error.response.data
              }
              if (error.response.data.idUser) {
                this.errores_seg = error.response.data.idUser
              }
            }
          })
      } else {
        this.dialogCellNumberWrong = true
      }
    },
    deleteResident () {
      const config = {
        method: 'delete',
        url: ' https://residencial-services.intrare.app/resident/' + this.idGuardDelete,
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config).then(ok => {
        console.log('Guard con ID = ', this.idGuardDelete + ' eliminado Correctamente.')
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_color', 'warning')
        this.$store.commit('snackbar_change_message', this.$t('mensaje_residente_eliminado'))
        this.getResidents()
        setTimeout(this.clear, 3000)
        this.deleteDialog = false
      })
        .catch(error => {
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    moveUpUserToResident () {
      this.errores = []
      this.loading = true
      const config = {
        method: 'PATCH',
        url: 'https://residencial-services.intrare.app/resident/make_from_guest/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          idUser: this.emailGuest
        }
      }
      axios(config)
        .then(ok => {
          this.loading = false
          this.getResidents()
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('msg_cambio_permisos'))
          this.dialogMoveUp = false
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    clear: function () {
      this.alerta = false
      this.errores = []
      this.errores_seg = []
      // this.$validator.reset()
      this.$store.commit('snackbar_change_color', 'success')
      this.$store.commit('snackbar_activate_false')
    },
    fillFields (item) {
      this.id_house = item.idHouse
      this.first_name = item.idUser.first_name
      this.last_name = item.idUser.last_name
      this.celular = item.idUser.cellNumber
      this.email = item.idUser.email
      this.email_aux = item.idUser.email
      this.celular_aux = item.idUser.cellNumber
      this.password = ''
      this.confirmation = ''
      this.change_password = false
      this.can_send = item.can_send
      this.notify_on_no_code_access = item.notify_on_no_code_access || false
      this.notify_on_worker_access = item.notify_on_worker_access || false
      this.resultFrontURL = item.idUser.idFront
      this.resultBackURL = item.idUser.idBack
      this.resultProfileURL = item.idUser.avatar
      this.resultAuxFrontURL = item.idUser.idFront
      this.resultAuxBackURL = item.idUser.idBack
      this.resultAuxProfileURL = item.idUser.avatar
      this.band_cellphone = true
    },
    customFilter (item, queryText) {
      const textOne = item.street.toLowerCase()
      const searchText = queryText.toLowerCase()
      return textOne.indexOf(searchText) > -1
    },
    cleanFields () {
      this.id_house = ''
      this.first_name = ''
      this.last_name = ''
      this.celular = ''
      this.email = ''
      this.email_aux = ''
      this.celular_aux = ''
      this.password = ''
      this.confirmation = ''
      this.change_password = true
      this.can_send = false
      this.notify_on_no_code_access = false
      this.notify_on_worker_access = false
      this.resultFrontURL = ''
      this.resultBackURL = ''
      this.resultProfileURL = ''
    },
    getCutingFront () {
      console.log('Datos de la imagen = ', this.imageFrontURL.size)
      const canvas = this.$refs.clipperImageFront.clip() // call component's clip method
      this.resultFrontURL = canvas.toDataURL('image/jpeg', 0.2) // canvas->image
      console.log(this.resultFrontURL)
      this.dialogImageFront = false
      if (this.bandGuest === true) {
        this.dialogGuest = true
      } else {
        this.dialog = true
      }
    },
    getCutingBack () {
      const canvas = this.$refs.clipperImageBack.clip() // call component's clip method
      this.resultBackURL = canvas.toDataURL('image/jpeg', 0.2) // canvas->image
      console.log(this.resultBackURL)
      this.dialogImageBack = false
      if (this.bandGuest === true) {
        this.dialogGuest = true
      } else {
        this.dialog = true
      }
    },
    getCutingProfile () {
      const canvas = this.$refs.clipperImageProfile.clip() // call component's clip method
      this.resultProfileURL = canvas.toDataURL('image/jpeg', 0.2) // canvas->image
      console.log(this.resultProfileURL)
      this.dialogImageProfile = false
      if (this.bandGuest === true) {
        this.dialogGuest = true
      } else {
        this.dialog = true
      }
    },
    dataURLtoFile (dataurl, filename) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    example: item => item.first_name + ' ' + item.last_name,
    onInput ({ number, isValid, country }) {
      console.log(number.e164)
      console.log(isValid)
      this.celular = number.e164
      this.band_cellphone = isValid
    }
  }
}
</script>

<style scoped>
    .edge {
        border-radius: 8px;
        border-color: #81c81b #81c81b #81c81b #81c81b;
        border-width: 3px 3px 3px 3px;
        text-align: center;
        border-style: solid solid solid solid;
    }
    .wrapper{
        width:200px;
        height:200px;
        position: relative;
        margin: 25px auto;
        overflow: hidden;
        border-radius:50%;
        border: 5px solid #81c81b;
    }
    .wrapper img{
        position: relative;
        width:100%;
        height:auto;
    }
    .splash-info {
        background: #ffffff;
        position: relative;
        z-index: 2;
        margin-bottom: 30px;
        text-align: center;
        font-size:15px;
        font-weight:bold;
    }
</style>
